<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g fill="none" fill-rule="evenodd">
      <g>
        <g transform="translate(-24 -26) translate(24 26)">
          <circle cx="12" cy="12" r="12" fill="#1FD876" />
          <g fill="#FFF" fill-rule="nonzero">
            <g>
              <path
                class="fly-ignore-color"
                d="M10.302.281L3.996 6.583 1.698 4.287c-.393-.38-1.018-.374-1.405.012-.386.386-.391 1.01-.012 1.404l3.006 3.004c.392.39 1.026.39 1.417 0l7.015-7.01c.38-.393.374-1.017-.012-1.404-.387-.386-1.012-.391-1.405-.012z"
                transform="translate(6 8)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'TickCircleIcon',
  props: {
    height: VueTypes.string.def('24'),
    width: VueTypes.string.def('24'),
  },
};
</script>

<style lang="scss"></style>
